import store from '../../../../../store';
import get from 'lodash/get';

export function getDefaultExpenseCategoryId(): number | null {
  const state = store.getState() as Record<string, unknown>;
  const categories = Object.values(
    (get(state, 'slot_categories.data', {}) as Record<
      string,
      { id?: number; slot_category_type?: string }
    >) ?? {}
  );
  const firstExpense = categories.find(
    c => c?.slot_category_type === 'EXPENSE'
  );
  return firstExpense?.id ?? null;
}

export function getDefaultCurrency(): string {
  const state = store.getState() as Record<string, unknown>;
  return String(
    get(state, 'auth.settings.settings.defaults_currency.value', 'USD')
  );
}
